import type { ProductColor } from "../types/configurator";

export const colors: ProductColor[] = [
  { id: "blanc", name: "Blanc", hex: "#FFFFFF" },
  { id: "noir", name: "Noir", hex: "#1A1A1A" },
  { id: "marine", name: "Bleu marine", hex: "#1F2A44" },
  { id: "bleu", name: "Bleu roi", hex: "#2547B8" },
  { id: "rouge", name: "Rouge cerise", hex: "#C8102E" },
  { id: "rose", name: "Rose poudré", hex: "#FFB3C8" },
  { id: "menthe", name: "Menthe", hex: "#2EF08F" },
  { id: "vert-sapin", name: "Vert sapin", hex: "#1E4D3A" },
  { id: "gris", name: "Gris chiné", hex: "#B8B8B4" },
  { id: "naturel", name: "Naturel", hex: "#EFE6D2" },
  { id: "kraft", name: "Kraft", hex: "#B58B5A" },
  { id: "argent", name: "Argent", hex: "#C9CCD1" },
  { id: "bambou", name: "Bambou", hex: "#D9B77E" },
];
